import { NgIfContext } from '@angular/common';
import { DestroyRef, Directive, inject, Input, OnChanges, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { MediaQuery } from '../services/media-query.service';

@Directive({
  selector: '[mediaIf]',
  standalone: true,
})
export class MediaIfDirective implements OnInit, OnChanges {
  @Input('mediaIf')
  breakpoint = '';

  @Input()
  mediaIfElse: TemplateRef<NgIfContext> | null = null;

  private thenViewCreated = false;
  private elseViewCreated = false;
  private destroyRef = inject(DestroyRef);

  constructor(
    private templateRef: TemplateRef<HTMLElement>,
    private viewContainer: ViewContainerRef,
    private media: MediaQuery,
  ) {}

  ngOnInit(): void {
    this.media.mediaChanged.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      if (this.media.is(this.breakpoint)) {
        this.createView();
      } else {
        this.clearView();
      }
    });
  }

  ngOnChanges(): void {
    if (this.media.is(this.breakpoint)) {
      this.createView();
    } else {
      this.clearView();
    }
  }

  private createView(): void {
    if (this.elseViewCreated) {
      this.viewContainer.clear();
      this.elseViewCreated = false;
    }
    if (!this.thenViewCreated) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.thenViewCreated = true;
    }
  }

  private clearView(): void {
    if (this.thenViewCreated) {
      this.viewContainer.clear();
      this.thenViewCreated = false;
    }
    if (this.mediaIfElse && !this.elseViewCreated) {
      this.viewContainer.createEmbeddedView(this.mediaIfElse);
      this.elseViewCreated = true;
    }
  }
}
